import React from 'react'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import AsyncSelect from 'react-select/lib/Async'
import { Button } from '../../styles/styled-elements'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper';
import SvgIcon from '@material-ui/core/SvgIcon';
import { emphasize } from '@material-ui/core/styles/colorManipulator'
import CheckCircle from '../icons/CheckCircle'
import CircleOutline from '../icons/CircleOutline'

const styles = theme => {
  return ({
    root: {
      flexGrow: 1,
      height: 250,
    },
    formContainer: {
      padding: 30,
    },
    input: {
      display: 'flex',
      padding: 0,
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
    },
    noOptionsMessage: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      fontSize: 16,
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing.unit,
      left: 0,
      right: 0,
    },
    formControl: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
    selectField: {
    },
    selectDropdownArrow: {
      color: theme.palette.text.secondary
    },
    formSectionHeading: {
      fontSize: 20,
      fontWeight: 500,
      marginTop: 18,
      marginBottom: 18,
    },
    inputRowGrid: {
      flexGrow: 1,
      width: '100%',
    },
    sensorsSelectHeading: {
      display: 'inline-flex',
      justifyContent: 'center',
      marginBottom: 10,
      textAlign: 'center'
    },
    sensorsSelectRowCell: {
      display: 'inline-flex',
      justifyContent: 'center',
    },
    graphSettingsUnitCell: {
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: 500,
      fontSize: '1.2em',
    },
    saveButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: 40,
    }
  }
)}

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function IndicatorSeparator() {
  return null
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {

  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function DropdownIndicator(props) {
  return <SvgIcon className={props.selectProps.classes.selectDropdownArrow}>
    <path d="M7 10l5 5 5-5z" />
  </SvgIcon>
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

const components = {
  Control,
  Menu,
  Option,
  Placeholder,
  NoOptionsMessage,
  IndicatorSeparator,
  DropdownIndicator,
  ValueContainer,
}

const HardwareInputsSettingsSection = ({inputType,inputsArray,sectionTitle,fieldLabel,classes,probeTypes,changeHandler,state}) => <div>
  <div className={classes.formSectionHeading}>{sectionTitle}</div>
  <div>
  {inputsArray.map((item,index) => <Grid container key={index} spacing={24}>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth={true} className={classes.formControl}>

        <TextField
          className={classes.textField}
          name={`${inputType}InputNames[${item.id}]`}
          id={`${inputType}-input-name-${item.id}`}
          label={`Label - ${fieldLabel} ${item.id}`}
          InputLabelProps={{
            shrink: true,
          }}
          value={state[`${inputType}InputLabels`][item.id] || ''}
          onChange={changeHandler(`${inputType}InputLabels`,item.id)}
        />

      </FormControl>
    </Grid>
    <Grid item xs={12} sm={6}>
      <FormControl key={index} fullWidth={true} className={classes.formControl}>

        <InputLabel htmlFor={`select-${inputType}-input-${item.id}`} shrink>{`Probe Type - ${fieldLabel} ${item.id}`}</InputLabel>
        <Select
          className={classes.selectField}
          inputProps={{
            name: `${inputType}Inputs[${item.id}]`,
            id: `select-${inputType}-input-${item.id}`,
          }}
          value={state[`${inputType}Inputs`][item.id] || ''}
          onChange={changeHandler(`${inputType}Inputs`,item.id)}
        >
          <MenuItem value="" key={0}>Select</MenuItem>
          {probeTypes && probeTypes.probeTypes && probeTypes.probeTypes.filter(probeTypeItem => ((probeTypeItem.input_type===item.input_type) && (item.sensor_variant ? (probeTypeItem.sensor_variant===item.sensor_variant) : true))).map((probeTypeItem,index) => <MenuItem value={probeTypeItem.id} key={index+1}>{`${probeTypeItem.name}`}</MenuItem>)}
        </Select>

      </FormControl>
    </Grid>

  </Grid>
  )}
</div></div>

const SensorsSelectHeading = styled.h3`
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 1em;
  font-weight: 500;
`

const Sdi12SensorEnabledButtonContainer = styled.div`
  &:hover {
    cursor: pointer;
  }
  svg {
    fill: ${ ({enabled}) => enabled ? '#02cc28' : '#C0C0C0' };
  }
`

const Sdi12SensorEnabledButton = ({inputId,depth,sensorKey,enabled,clickHandler}) => <Sdi12SensorEnabledButtonContainer enabled={enabled} onClick={clickHandler.bind(this,inputId,depth,sensorKey,!!!enabled)}>
  {enabled && <CheckCircle />}
  {!enabled && <CircleOutline />}
</Sdi12SensorEnabledButtonContainer>

const Sdi12InputsSettingsSection = ({inputType,inputsArray,sectionTitle,fieldLabel,classes,probeTypes,changeHandler,sensorEnabledButtonClickHandler,state}) => <div>
  <div className={classes.formSectionHeading}>{sectionTitle}</div>
  <div>
  {inputsArray.map((item,index) => {
    if (typeof state[`${inputType}Inputs`][item.id]==='undefined') return null
    const selectedProbe = probeTypes.probeTypes.find(o => o.id===state[`${inputType}Inputs`][item.id])
    const sdi12Vars = {}
    const sdi12SensorsEnabled = state.sdi12SensorsEnabled[item.id]
    if (selectedProbe && selectedProbe.sdi12_sensor_config) {
      sdi12Vars['units'] = selectedProbe.sdi12_sensor_config.units
      sdi12Vars['sensors'] = selectedProbe.sdi12_sensor_config.sensors
      sdi12Vars['probe_levels_array'] = state[`${inputType}DepthLabelsHashes`][item.id]
      sdi12Vars['sensorsEnabledGridWidth'] = Math.ceil(12/(1+sdi12Vars['sensors'].length))
    }
    return <Grid container className={classes.inputRowGrid} spacing={24} key={index}>
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth={true} className={classes.formControl}>

        <TextField
          className={classes.textField}
          name={`${inputType}InputNames[${item.id}]`}
          id={`${inputType}-input-name-${item.id}`}
          label={`Label - ${fieldLabel} ${item.id}`}
          InputLabelProps={{
            shrink: true,
          }}
          value={state[`${inputType}InputLabels`][item.id]}
          onChange={changeHandler(`${inputType}InputLabels`,item.id)}
        />

      </FormControl>
    </Grid>
    <Grid item xs={12} sm={6}>

      <FormControl key={index} fullWidth={true} className={classes.formControl}>

        <InputLabel htmlFor={`select-${inputType}-input-${item.id}`} shrink>{`Probe Type - ${fieldLabel} Input ${item.id}`}</InputLabel>
        <Select
          className={classes.selectField}
          inputProps={{
            name: `${inputType}Inputs[${item.id}]`,
            id: `select-${inputType}-input-${item.id}`,
          }}
          value={state[`${inputType}Inputs`][item.id]}
          onChange={changeHandler(`${inputType}Inputs`,item.id)}
        >
          <MenuItem value="" key={0}>Select</MenuItem>
          {probeTypes && probeTypes.probeTypes && probeTypes.probeTypes.filter(probeTypeItem => ((probeTypeItem.input_type===item.input_type) && (item.sensor_variant ? (probeTypeItem.sensor_variant===item.sensor_variant) : true))).map((probeTypeItem,index) => <MenuItem value={probeTypeItem.id} key={index+1}>{`${probeTypeItem.name}`}</MenuItem>)}
        </Select>

      </FormControl>

    </Grid>

    { selectedProbe &&
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth={true} className={classes.formControl}>
          <InputLabel htmlFor={`select-${inputType}-input-${item.id}`} shrink>{`Depth Unit - ${fieldLabel} Input ${item.id}`}</InputLabel>
          <Select
            className={classes.selectField}
            error={state.dataLoggerDeviceError}
            inputProps={{
              name: `${inputType}DepthUnit[${item.id}]`,
              id: `select-${inputType}-depth-unit-${item.id}`,
            }}
            value={state[`${inputType}DepthUnits`][item.id]}
            onChange={changeHandler(`${inputType}DepthUnits`,item.id)}
          >
            <MenuItem value="mm" key={0}>Millimetres</MenuItem>
            <MenuItem value="cm" key={1}>Centimetres</MenuItem>
            <MenuItem value="in" key={2}>Inches</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    }
    { selectedProbe &&
      <Grid item xs={12} sm={6} md={4}>

        <FormControl fullWidth={true} className={classes.formControl}>

          <TextField
            className={classes.textField}
            name={`${inputType}SurfaceOffsets[${item.id}]`}
            id={`${inputType}-surface-offset-${item.id}`}
            label={`Surface Offset - ${fieldLabel} ${item.id}`}
            InputLabelProps={{
              shrink: true,
            }}
            type="number"
            inputProps={{
              step: 0.1,
            }}
            value={state[`${inputType}SurfaceOffsets`][item.id]}
            onChange={changeHandler(`${inputType}SurfaceOffsets`,item.id)}
          />

        </FormControl>

      </Grid>
    }
    { selectedProbe &&
      <Grid item xs={12} sm={6} md={4}>

        <FormControl fullWidth={true} className={classes.formControl}>
          <InputLabel htmlFor={`select-${inputType}-root-zone-depth-${item.id}`} shrink>{`Root Zone Depth - ${fieldLabel} Input ${item.id}`}</InputLabel>
          <Select
            className={classes.selectField}
            error={state.dataLoggerDeviceError}
            inputProps={{
              name: `${inputType}RootZoneDepths[${item.id}]`,
              id: `select-${inputType}-root-zone-depth-${item.id}`,
            }}
            value={state[`${inputType}RootZoneDepths`][item.id]}
            onChange={changeHandler(`${inputType}RootZoneDepths`,item.id)}
          >
            <MenuItem value="" key={0}>Select</MenuItem>
            {Object.keys(sdi12Vars['probe_levels_array']).map((key,index) => {
              const probeLevel = sdi12Vars['probe_levels_array'][key]
              return <MenuItem value={key} key={index+1}>{probeLevel}</MenuItem>
            })
           }
          </Select>
        </FormControl>

      </Grid>
    }
    { selectedProbe &&
      <Grid item xs={12}>
        <SensorsSelectHeading>{`Select Sensors - ${fieldLabel} Input ${item.id}`}</SensorsSelectHeading>
        <Grid container key={0}>
          <Grid item xs={sdi12Vars['sensorsEnabledGridWidth']} md={2} className={classes.sensorsSelectHeading} key={0}></Grid>
          {sdi12Vars['sensors'].map((sensor,sensorIndex) => {
            const heading=`${sensor.label} (${selectedProbe.units.find(o => o.unit_key===sensor.unit_key).unit})`
            return <Grid item xs={sdi12Vars['sensorsEnabledGridWidth']} md={2} className={classes.sensorsSelectHeading} key={sensorIndex+1}>{heading}</Grid>
          })}
        </Grid>
        {Object.keys(sdi12Vars['probe_levels_array']).map((key,rowIndex) => {
          const probeLevel = sdi12Vars['probe_levels_array'][key]
          return <Grid container key={rowIndex+1}>
            <Grid item xs={sdi12Vars['sensorsEnabledGridWidth']} md={2} key={0}>{`${probeLevel}`}</Grid>
            {sdi12Vars['sensors'].map((sensor,sensorIndex) => {
              const sensorKey = sensor['sensor_key']
              return <Grid item xs={sdi12Vars['sensorsEnabledGridWidth']} md={2} className={classes.sensorsSelectRowCell} key={sensorIndex+1}>
                <Sdi12SensorEnabledButton
                  enabled={(sdi12SensorsEnabled[sensorKey] && sdi12SensorsEnabled[sensorKey][rowIndex+1]) || false}
                  inputId={item.id}
                  depth={rowIndex+1}
                  sensorKey={sensorKey}
                  clickHandler={sensorEnabledButtonClickHandler}
                />
              </Grid>}
            )}
          </Grid>
        })}
      </Grid>
    }
  </Grid>}
  )}
  </div>
</div>


class SiteConfigForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      slug: '',
      name: '',
      companySlug: '',
      timezoneId: '',
      loggingIntervalId: '',
      dataLoggerDevice: '',
      dataLoggerDeviceTypeModelKey: '',
      dataLoggerDeviceSerialNo: '',
      analogueInputs: [],
      analogueInputLabels: [],
      voltageInputs: [],
      voltageInputLabels: [],
      pulseSwitchInputs: [],
      pulseSwitchInputLabels: [],
      sdi12InputLabels: [],
      sdi12Inputs: [],
      sdi12SurfaceOffsets: [],
      sdi12DepthUnits: [],
      sdi12DepthLabelsHashes: [],
      sdi12RootZoneDepths: [],
      sdi12SensorsEnabled: [],
      allProbeInputIds: [],
      units: [],
      graphMin: {},
      graphMax: {},
      graphFullRefillPoint: {
        unit: '',
        unit_key: '',
        refill_point: '',
        full_point: '',
      },
      hasErrors: false,
      formErrors: null,
      errors: null
    }
  }

  defaultVars = {
    sdi12DepthUnit: 'mm'
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps,prevState) {

    const prevSite = prevProps.sites.site
    const site = this.props.sites.site
    if (site && (
      (!prevSite || (prevSite.id!=site.id)) ||
      (!prevProps.probeTypes.probeTypes.length && this.props.probeTypes.probeTypes.length)
    ))
      this.populateSiteForm(site)
    if (prevState.companySlug && (prevState.companySlug!==this.state.companySlug))
      this.props.updateDataLoggerDevices(this.state.companySlug)

    const inputIdStatesArray = ['analogueInputs', 'voltageInputs', 'pulseSwitchInputs', 'sdi12Inputs', 'sdi12SensorsEnabled']
    inputIdStatesArray.forEach((stateKey) => {
      if (prevState[stateKey] && Object.keys(prevState[stateKey]).length && (prevState[stateKey]!==this.state[stateKey])) {
        this.updateUnits()
        return false
      }
    })

    const sdi12DepthLabelStatesArray = ['sdi12Inputs', 'sdi12SurfaceOffsets', 'sdi12DepthUnits']
    sdi12DepthLabelStatesArray.forEach((stateKey) => {
      if (prevState[stateKey] && Object.keys(prevState[stateKey]).length && (prevState[stateKey]!==this.state[stateKey])) {
        this.updateSdi12DepthLabelsHashes()
        return false
      }
    })

  }

  addUpdateUnitInUnitsArray = (array,item) => {
    const newArray = [...array]
    const existingUnitIndex = newArray.findIndex(o => o.unit_key===item.unit_key)
    if (existingUnitIndex > -1) {
      if (item.graph_min_include_value < newArray[existingUnitIndex].graph_min_include_value) newArray[existingUnitIndex].graph_min_include_value=item.graph_min_include_value
      if (item.graph_max_include_value > newArray[existingUnitIndex].graph_max_include_value) newArray[existingUnitIndex].graph_max_include_value=item.graph_max_include_value
      if (item.graph_axis_min_value_default < newArray[existingUnitIndex].graph_axis_min_value_default) newArray[existingUnitIndex].graph_axis_min_value_default=item.graph_axis_min_value_default
      if (item.graph_axis_max_value_default > newArray[existingUnitIndex].graph_axis_max_value_default) newArray[existingUnitIndex].graph_axis_max_value_default=item.graph_axis_max_value_default
    } else {
      newArray.push({...item})
    }
    return newArray
  }

  sensorEnabled = (sensorsEnabledObject,key) => {
    const sensorDepthsObject = sensorsEnabledObject[key]
    if (!sensorDepthsObject) return false
    let enabled = false
    Object.keys(sensorDepthsObject).forEach((depth,index) => {
      if (sensorDepthsObject[depth]===true) {
        enabled=true
        return false
      }
    })
    return enabled
  }

  updateUnits = () => {

    const { analogueInputs, voltageInputs, pulseSwitchInputs, sdi12Inputs, sdi12SensorsEnabled, graphMin, graphMax } = this.state
    const unitsObj = this.getUnits(analogueInputs,voltageInputs,pulseSwitchInputs,sdi12Inputs,sdi12SensorsEnabled)

    const newUnitsMin = {}
    const newUnitsMax = {}
    unitsObj.units.forEach((unit) => {
      newUnitsMin[unit.unit_key] = (newUnitsMin[unit.unit_key] && (newUnitsMin[unit.unit_key] < unit.graph_axis_min_value_default)) ? newUnitsMin[unit.unit_key] : unit.graph_axis_min_value_default,
      newUnitsMax[unit.unit_key] = (newUnitsMax[unit.unit_key] && (newUnitsMax[unit.unit_key] > unit.graph_axis_max_value_default)) ? newUnitsMax[unit.unit_key] : unit.graph_axis_max_value_default
    })

    this.setState({
      units: unitsObj.units,
      allProbeInputIds: unitsObj.allProbeInputIds,
      refillFullPointUnit: unitsObj.refillFullPointUnit,
      graphMin: newUnitsMin,
      graphMax: newUnitsMax,
    })

  }

  getUnits = (analogueInputs,voltageInputs,pulseSwitchInputs,sdi12Inputs,sdi12SensorsEnabled) => {

    const allProbeInputIds = []
    const sensorsPresent = {}
    const sensorsUtilised = []
    let refillFullPointUnit = null
    let units = []
    const inputsStatesArray = [ analogueInputs, voltageInputs, pulseSwitchInputs ]

    inputsStatesArray.forEach(inputsArray => {
      if (!inputsArray) return true
      inputsArray.forEach((inputId,index) => {
        if (typeof inputId==='undefined') return true
        allProbeInputIds.push(inputId)
      })
    })

    sdi12Inputs.forEach((inputId,inputsIndex) => {
      if (typeof inputId==='undefined') return true
      if (inputId==='') return true
      const probeType = this.props.probeTypes.probeTypes.find(o => o.id==inputId)
      probeType.sdi12_sensor_config && probeType.sdi12_sensor_config.sensors.forEach((sensor) => {
        const sensorKey = sensor['sensor_key']
        if (sensorsPresent[sensorKey]) return true
        sensorsPresent[sensorKey] = this.sensorEnabled(sdi12SensorsEnabled[inputsIndex],sensorKey)
        if (sensorsPresent[sensorKey]===true) sensorsUtilised.push(sensor)
      })
      allProbeInputIds.push(inputId)
    })

    allProbeInputIds.forEach((inputId,index) => {
      if (typeof inputId==='undefined') return true
      if (inputId==='') return true
      const probeType = this.props.probeTypes.probeTypes.find(o => o.id==inputId)
      if (!probeType) return false
      probeType.units.forEach(unit => {
        let sensor
        let unitToAdd
        if (probeType.sensor_variant==="sdi12_multi") {
          sensor = sensorsUtilised.find(o => o.unit_key===unit.unit_key)
        } else {
          sensor = probeType.sensors.find(o => o.unit_key===unit.unit_key)
        }
        if (!sensor) return true
        const { graph_min_include_value, graph_max_include_value, graph_axis_min_value_default, graph_axis_max_value_default } = sensor
        unitToAdd = {
          ...unit,
          graph_min_include_value,
          graph_max_include_value,
          graph_axis_min_value_default,
          graph_axis_max_value_default,
        }
        units = this.addUpdateUnitInUnitsArray(units,unitToAdd)
        if (["kpa","percent"].includes(unitToAdd.unit_key)) {
          refillFullPointUnit=unitToAdd
        }
      })
    })

    return {
      allProbeInputIds: allProbeInputIds,
      refillFullPointUnit: refillFullPointUnit,
      units: units,
    }

  }

  updateSdi12DepthLabelsHashes = () => {

    const { sdi12Inputs, sdi12DepthUnits, sdi12SurfaceOffsets } = this.state
    const sdi12DepthUnitsDefault = this.defaultVars.sdi12DepthUnit
    const { probeTypes } = this.props

    const sdi12DepthLabelsHashes = this.getSdi12DepthLabelsHashes(sdi12Inputs,sdi12DepthUnits,sdi12DepthUnitsDefault,sdi12SurfaceOffsets,probeTypes)

    this.setState({
      sdi12DepthLabelsHashes: sdi12DepthLabelsHashes
    })

  }

  getSdi12DepthLabelsHashes = (sdi12Inputs,sdi12DepthUnits,sdi12DepthUnitsDefault,sdi12SurfaceOffsets,probeTypes) => {

    const sdi12DepthLabelsHashes = []

    sdi12Inputs.forEach((probeTypeId,index) => {

      if (typeof probeTypeId==='undefined') return true

      const selectedProbe = probeTypes.probeTypes.find(o => o.id===probeTypeId)
      if (!selectedProbe) return true
      const probeLevelsArray = []
      const surfaceOffset = sdi12SurfaceOffsets[index] || 0
      const selectedDepthUnit = sdi12DepthUnits[index] || sdi12DepthUnitsDefault
      const depthUnit = selectedProbe.sdi12_sensor_config.depth_unit
      const unitsPerLevel = selectedProbe.sdi12_sensor_config.units_per_level
      const noLevels = selectedProbe.sdi12_sensor_config.no_levels

      let calculatedUnitsPerLevel = unitsPerLevel
      let probeDepthLabelsHash = {}

      if (depthUnit=='mm') {
        if (selectedDepthUnit=='cm') calculatedUnitsPerLevel=(unitsPerLevel/10)
        if (selectedDepthUnit=='in') calculatedUnitsPerLevel=(unitsPerLevel/25)
        if (selectedDepthUnit=='mm') calculatedUnitsPerLevel=unitsPerLevel
      } else if (depthUnit=='cm') {
        if (selectedDepthUnit=='cm') calculatedUnitsPerLevel=unitsPerLevel
        if (selectedDepthUnit=='in') calculatedUnitsPerLevel=(unitsPerLevel/2.5)
        if (selectedDepthUnit=='mm') calculatedUnitsPerLevel=(unitsPerLevel*10)
      } else if (depthUnit=='in') {
        if (selectedDepthUnit=='cm') calculatedUnitsPerLevel=(unitsPerLevel*2.5)
        if (selectedDepthUnit=='in') calculatedUnitsPerLevel=unitsPerLevel
        if (selectedDepthUnit=='mm') calculatedUnitsPerLevel=(unitsPerLevel*25)
      }

      let i=1
      while (i <= noLevels) {
        probeDepthLabelsHash[i] = `${parseFloat(i++*calculatedUnitsPerLevel)+parseFloat(surfaceOffset)}${selectedDepthUnit}`
      }

      sdi12DepthLabelsHashes[index] = probeDepthLabelsHash

    })

    return sdi12DepthLabelsHashes

  }

  populateSiteForm = site => {

    const { slug, name, company_slug, timezone_id, site_config, units, graph_min_max, refill_full_point } = site
    const { site_logging_interval, data_logger_device, analogue_inputs, voltage_inputs, pulse_switch_inputs, sdi12_inputs, deploy_at, version, active } = site_config
    const { probeTypes } = this.props
    console.log('probeTypes.probeTypes',probeTypes.probeTypes)
    console.log('probeTypes.probeTypes.length',probeTypes.probeTypes.length)
    if ((!probeTypes.probeTypes) || (!probeTypes.probeTypes.length)) return true
    const sdi12DepthUnitsDefault = this.defaultVars.sdi12DepthUnit
    const loggingIntervalId = site_logging_interval.id
    const dataLoggerDeviceTypeModelKey = data_logger_device.data_logger_device_type.model_key
    const dataLoggerDeviceSerialNo = data_logger_device.serial_no
    const dataLoggerDevice = `${dataLoggerDeviceTypeModelKey}:${dataLoggerDeviceSerialNo}`
    const analogueInputLabels = []
    const analogueInputs = []
    const voltageInputLabels = []
    const voltageInputs = []
    const pulseSwitchInputLabels = []
    const pulseSwitchInputs = []
    const sdi12InputLabels = []
    const sdi12Inputs = []
    const sdi12SurfaceOffsets = []
    const sdi12DepthUnits = []
    const sdi12RootZoneDepths = []
    const sdi12SensorsEnabled = []
    analogue_inputs.forEach(item => {
      analogueInputLabels[item.hardware_input_no]=item.label
      analogueInputs[item.hardware_input_no]=item.probe_type.id
    })
    voltage_inputs.forEach(item => {
      voltageInputLabels[item.hardware_input_no]=item.label
      voltageInputs[item.hardware_input_no]=item.probe_type.id
    })
    pulse_switch_inputs.forEach(item => {
      pulseSwitchInputLabels[item.hardware_input_no]=item.label
      pulseSwitchInputs[item.hardware_input_no]=item.probe_type.id
    })
    sdi12_inputs.forEach(item => {
      const probeType = item.probe_type
      sdi12InputLabels[item.hardware_input_no]=item.label
      sdi12Inputs[item.hardware_input_no]=probeType.id
      sdi12SurfaceOffsets[item.hardware_input_no]=item.surface_offset ? parseFloat(item.surface_offset) : 0
      sdi12DepthUnits[item.hardware_input_no]=item.depth_unit || sdi12DepthUnitsDefault
      sdi12RootZoneDepths[item.hardware_input_no]=item.root_zone_depth || ''
      sdi12SensorsEnabled[item.hardware_input_no]=item.sensors_enabled || {}
    })

    const sdi12DepthLabelsHashes = this.getSdi12DepthLabelsHashes(sdi12Inputs,sdi12DepthUnits,sdi12DepthUnitsDefault,sdi12SurfaceOffsets,probeTypes)
    const unitsObj = this.getUnits(analogueInputs,voltageInputs,pulseSwitchInputs,sdi12Inputs,sdi12SensorsEnabled)

    const graphMin = {}
    const graphMax = {}
    unitsObj.units.forEach((unit) => {
      graphMin[unit.unit_key] = (graph_min_max && graph_min_max[unit.unit_key] && graph_min_max[unit.unit_key]['min']) || unit.graph_axis_min_value_default
      graphMax[unit.unit_key] = (graph_min_max && graph_min_max[unit.unit_key] && graph_min_max[unit.unit_key]['max']) || unit.graph_axis_max_value_default
    })

    const { refillFullPointUnit } = unitsObj

    const graphFullRefillPoint = {
      unit: refillFullPointUnit['unit'],
      unit_key: refillFullPointUnit['unit_key'],
      refill_point: (refill_full_point && refill_full_point['refill_point']) ? refill_full_point['refill_point'] : '',
      full_point: (refill_full_point && refill_full_point['full_point']) ? refill_full_point['full_point'] : '',
    }

    this.setState({
      slug: slug,
      name: name,
      companySlug: company_slug,
      timezoneId: timezone_id,
      loggingIntervalId: loggingIntervalId,
      dataLoggerDeviceTypeModelKey: dataLoggerDeviceTypeModelKey,
      dataLoggerDeviceSerialNo: dataLoggerDeviceSerialNo,
      dataLoggerDevice: dataLoggerDevice,
      analogueInputLabels: analogueInputLabels,
      analogueInputs: analogueInputs,
      voltageInputLabels: voltageInputLabels,
      voltageInputs: voltageInputs,
      pulseSwitchInputLabels: pulseSwitchInputLabels,
      pulseSwitchInputs: pulseSwitchInputs,
      sdi12InputLabels: sdi12InputLabels,
      sdi12Inputs: sdi12Inputs,
      sdi12SurfaceOffsets: sdi12SurfaceOffsets,
      sdi12DepthUnits: sdi12DepthUnits,
      sdi12DepthLabelsHashes: sdi12DepthLabelsHashes,
      sdi12RootZoneDepths: sdi12RootZoneDepths,
      sdi12SensorsEnabled: sdi12SensorsEnabled,
      units: unitsObj.units,
      allProbeInputIds: unitsObj.allProbeInputIds,
      graphFullRefillPoint: graphFullRefillPoint,
      graphMin: graphMin,
      graphMax: graphMax,
    })

  }

  validate = (callback) => {
    const errors = {}
    const {
      slug,
      name,
      companySlug,
      timezoneId,
      loggingIntervalId,
      dataLoggerDeviceTypeModelKey,
      dataLoggerDeviceSerialNo,
      dataLoggerDevice,
      analogueInputLabels,
      analogueInputs,
      voltageInputLabels,
      voltageInputs,
      pulseSwitchInputLabels,
      pulseSwitchInputs,
      sdi12InputLabels,
      sdi12Inputs,
      sdi12SurfaceOffsets,
      sdi12DepthUnits,
      sdi12SensorsEnabled,
      allProbeInputIds,
      units,
      graphMin,
      graphMax,
    } = this.state
    if (!companySlug) {
      errors['companySlug'] = 'Company is required'
    }
    if ( (!name) || (name.length < 3) ) {
      errors['name'] = 'Name is required and must be 3 or more characters'
    }
    if ( (!timezoneId) && (timezoneId!==0)) {
      errors['timezoneId'] = 'Timezone is required'
    }
    if ( (!loggingIntervalId) && (loggingIntervalId!==0)) {
      errors['loggingIntervalId'] = 'Logging interval is required'
    }
    if (!dataLoggerDevice) {
      errors['dataLoggerDevice'] = 'Data logger device is required'
    }
    if ((!allProbeInputIds) || (!allProbeInputIds.length)) {
      errors['noHardwareInputsSelected'] = 'At least one hardware input must be selected'
    }
    if (Object.keys(errors).length) {
      this.setState({
        hasErrors: true,
        errors: errors
      })
    } else {
      const submitParams = this.getSubmitParams()
      callback.call(this,submitParams)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({
      hasErrors: false,
      formErrors: null,
      errors: null,
    })
    this.validate.call(this,this.props.submitHandler)
  }

  getSubmitParams = () => {
    const {
      slug,
      name,
      companySlug,
      timezoneId,
      loggingIntervalId,
      dataLoggerDeviceTypeModelKey,
      dataLoggerDeviceSerialNo,
      dataLoggerDevice,
      analogueInputLabels,
      analogueInputs,
      voltageInputLabels,
      voltageInputs,
      pulseSwitchInputLabels,
      pulseSwitchInputs,
      sdi12InputLabels,
      sdi12Inputs,
      sdi12SurfaceOffsets,
      sdi12DepthUnits,
      sdi12DepthLabelsHashes,
      sdi12RootZoneDepths,
      sdi12SensorsEnabled,
      allProbeInputIds,
      units,
      graphMin,
      graphMax,
      graphFullRefillPoint,
    } = this.state

    const paramsObj = {
      name,
      company_slug: companySlug,
      slug,
      timezone_id: timezoneId,
      data_logger_device_type_model_key: dataLoggerDeviceTypeModelKey,
      data_logger_device_serial_no: dataLoggerDeviceSerialNo,
      units: units,
      refill_full_point: {},
      graph_min_max: {},
      latest_site_config_attributes: {
        data_logger_device_type_model_key: dataLoggerDeviceTypeModelKey,
        data_logger_device_serial_no: dataLoggerDeviceSerialNo,
        site_logging_interval_peak_id: loggingIntervalId,
        hardware_analogue_inputs: {},
        hardware_voltage_inputs: {},
        hardware_pulse_switch_inputs: {},
        hardware_sdi12_inputs: {},
      }
    }

    const simpleInputSubmitObjects = {
      hardware_analogue_inputs: [ analogueInputs, analogueInputLabels ],
      hardware_voltage_inputs: [ voltageInputs, voltageInputLabels ],
      hardware_pulse_switch_inputs: [ pulseSwitchInputs, pulseSwitchInputLabels ],
    }
    Object.keys(simpleInputSubmitObjects).forEach((submitObjKey,submitObjIndex) => {
      simpleInputSubmitObjects[submitObjKey][0].forEach((probeTypeId,index) => {
        if (typeof probeTypeId==='undefined') return true
        paramsObj['latest_site_config_attributes'][submitObjKey][index]={
          probe_type_id: probeTypeId,
          label: simpleInputSubmitObjects[submitObjKey][1][index]
        }
      })
    })
    sdi12Inputs.forEach((probeTypeId,index) => {
      if (typeof probeTypeId==='undefined') return true
      paramsObj['latest_site_config_attributes']['hardware_sdi12_inputs'][index]={
          probe_type_id: probeTypeId,
          label: sdi12InputLabels[index],
          surface_offset: sdi12SurfaceOffsets[index],
          depth_unit: sdi12DepthUnits[index],
          sensors_enabled: sdi12SensorsEnabled[index],
          root_zone_depth: sdi12RootZoneDepths[index],
          depth_labels: sdi12DepthLabelsHashes[index],
      }
    })
    units.forEach((unit) => {
      const { unit_key } = unit
      paramsObj['graph_min_max'][unit_key] = {}
      paramsObj['graph_min_max'][unit_key]['min'] = graphMin[unit_key]
      paramsObj['graph_min_max'][unit_key]['max'] = graphMax[unit_key]
    })
    paramsObj['refill_full_point']['unit_key'] = graphFullRefillPoint['unit_key']
    paramsObj['refill_full_point']['refill_point'] = graphFullRefillPoint['refill_point']
    paramsObj['refill_full_point']['full_point'] = graphFullRefillPoint['full_point']

    return paramsObj

  }

  formatCompanyItem = item => { return { value: item.slug, label: `${item.name}` }}

  defaultCompanies = () => this.props.childCompanies.childCompanies
    .slice(0,10)
    .map(item => this.formatCompanyItem(item))

  loadCompanyOptions = (inputValue, callback) => {
    const options = this.props.childCompanies.childCompanies
    .filter(({name}) => name.toLowerCase().includes(inputValue.toLowerCase()))
    .slice(0,10)
    .map(item => this.formatCompanyItem(item))
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  formatTimezoneItem = item => { return { value: item.id, label: `${item.name} (${item.utc_offset_label})` }}

  defaultTimezones = () => this.props.timezones.timezones
    .slice(0,10)
    .map(item => this.formatTimezoneItem(item))

  loadTimezoneOptions = (inputValue, callback) => {
    const options = this.props.timezones.timezones
    .filter(({name, utc_offset_label}) => name.toLowerCase().includes(inputValue.toLowerCase()) || utc_offset_label.toLowerCase().includes(inputValue.toLowerCase()))
    .slice(0,10)
    .map(item => this.formatTimezoneItem(item))
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  getSelectValue = (options,paramName,value,formatter) => {
    if (!value) return null
    const valueObject = options.find(item => item[paramName]==value)
    return formatter(valueObject)
  }

  handleAutocompleteChange = name => ({ value }) => {
    this.setState({ [name]: value })
  }

  handleStateObjectChange = (objectName,key) => event => {
    let updateObject
    if (Array.isArray(this.state[objectName])) {
      updateObject = [...this.state[objectName]]
    } else {
      updateObject = { ...this.state[objectName] }
    }
    if (event.target.value==='') {
      updateObject.splice(key,1)
    } else {
      updateObject[key] = event.target.value
    }
    this.setState({[objectName]: updateObject})
  }

  sdi12SensorEnabledButtonClickHandler = (inputId,depth,sensorKey,enabled) => {
    const sdi12SensorsEnabled = { ...this.state.sdi12SensorsEnabled }
    const newSensorsEnabledObj = { ...sdi12SensorsEnabled[inputId] }
    if (!newSensorsEnabledObj[sensorKey]) newSensorsEnabledObj[sensorKey]={}
    newSensorsEnabledObj[sensorKey][depth]=enabled
    sdi12SensorsEnabled[inputId]=newSensorsEnabledObj
    this.setState({ sdi12SensorsEnabled: sdi12SensorsEnabled })
    this.updateUnits()
  }

  handleKeyedInputChange = (stateKey,unitKey) => event => {
    const stateObj = { ...this.state[stateKey] }
    stateObj[unitKey] = event.target.value
    this.setState({[stateKey]: stateObj})
  }

  handleInputChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  renderBody = (props,state) => {

    const { classes, sites, siteLoggingIntervals, dataLoggerDevices } = props
    const { site } = sites
    const siteConfig = site && site.site_config
    const dataLoggerDevice = siteConfig && siteConfig.data_logger_device
    const analogueInputs = dataLoggerDevice && dataLoggerDevice.inputs.filter(item => item.input_type==="analogue")
    const voltageInputs = dataLoggerDevice && dataLoggerDevice.inputs.filter(item => item.input_type==="voltage")
    const pulseSwitchInputs = dataLoggerDevice && dataLoggerDevice.inputs.filter(item => item.input_type==="pulse_switch")
    const sdi12Inputs = dataLoggerDevice && dataLoggerDevice.inputs.filter(item => item.input_type==="sdi12")

    const selectStyles = {
      input: base => ({
        ...base,
        '& input': {
          font: 'inherit',
        },
      }),
    }

    return <Paper className={props.classes.formContainer}>
      <form onSubmit={this.handleSubmit}>
        <div className={props.classes.formSectionHeading}>Basic Info</div>
        <FormControl fullWidth={true} className={props.classes.formControl} error={state.errors && state.errors.companySlug && state.errors.companySlug.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={state.errors && state.errors.companySlug}
            inputProps={{
              name: 'companySlug',
              id: 'select-company',
            }}
            textFieldProps={{
              label: 'Company',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.childCompanies.childCompanies,'slug',state.companySlug,this.formatCompanyItem)}
            loadOptions={this.loadCompanyOptions}
            defaultOptions={this.defaultCompanies()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.handleAutocompleteChange('companySlug')}
          />
          <FormHelperText id="textinput-company-error">{state.errors && state.errors.companySlug}</FormHelperText>
        </FormControl>
        <FormControl fullWidth={true} className={props.classes.formControl} error={state.errors && state.errors.name && state.errors.name.length}>
          <TextField
            className={props.classes.textField}
            error={state.errors && state.errors.name}
            id="textinput-name"
            name="name"
            label="Name"
            InputLabelProps={{
              shrink: true,
            }}
            value={state.name}
            onChange={this.handleInputChange}
          />
          <FormHelperText id="textinput-name-error">{state.errors && state.errors.name}</FormHelperText>
        </FormControl>
        <FormControl fullWidth={true} className={props.classes.formControl} error={state.errors && state.errors.timezoneId && state.errors.timezoneId.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={state.errors && state.errors.timezoneId}
            inputProps={{
              name: 'timezoneId',
              id: 'select-timezone',
            }}
            textFieldProps={{
              label: 'Timezone',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.timezones.timezones,'id',state.timezoneId,this.formatTimezoneItem)}
            loadOptions={this.loadTimezoneOptions}
            defaultOptions={this.defaultTimezones()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.handleAutocompleteChange('timezoneId')}
          />
          <FormHelperText id="textinput-timezone-error">{state.errors && state.errors.timezoneId}</FormHelperText>
        </FormControl>
        <FormControl fullWidth={true} className={props.classes.formControl} error={state.errors && state.errors.loggingIntervalId && state.errors.loggingIntervalId.length}>
          <InputLabel htmlFor="select-logging-interval" shrink>Logging Interval</InputLabel>
          <Select
            className={props.classes.selectField}
            error={state.errors && state.errors.loggingIntervalId}
            inputProps={{
              name: 'loggingIntervalId',
              id: 'select-logging-interval',
            }}
            value={state.loggingIntervalId}
            onChange={this.handleInputChange}
          >
            <MenuItem value="" key={0}>Select</MenuItem>
            {props.siteLoggingIntervals && props.siteLoggingIntervals.siteLoggingIntervals && props.siteLoggingIntervals.siteLoggingIntervals.map((item,index) => <MenuItem value={item.id} key={index+1}>{item.label}</MenuItem>)}
          </Select>
          <FormHelperText id="textinput-logging-interval-error">{state.errors && state.errors.loggingIntervalId}</FormHelperText>
        </FormControl>
        <FormControl fullWidth={true} className={props.classes.formControl} error={state.errors && state.errors.dataLoggerDevice && state.errors.dataLoggerDevice.length}>
          <InputLabel htmlFor="select-logging-interval" shrink>Data Logger Device</InputLabel>
          <Select
            className={props.classes.selectField}
            error={state.errors && state.errors.dataLoggerDevice}
            inputProps={{
              name: 'dataLoggerDevice',
              id: 'select-data-logger-device',
            }}
            value={state.dataLoggerDevice}
            onChange={this.handleInputChange}
          >
            <MenuItem value="" key={0}>Select</MenuItem>
            {props.dataLoggerDevices && props.dataLoggerDevices.dataLoggerDevices && props.dataLoggerDevices.dataLoggerDevices.map((item,index) => <MenuItem value={`${item.data_logger_device_type.model_key}:${item.serial_no}`} key={index+1}>{`${item.serial_no} - ${item.data_logger_device_type.name}`}</MenuItem>)}
          </Select>
          <FormHelperText id="textinput-data-logger-device-error">{state.errors && state.errors.dataLoggerDevice}</FormHelperText>
        </FormControl>
        {
          analogueInputs && (analogueInputs.length) && <HardwareInputsSettingsSection
            inputType={'analogue'}
            inputsArray={analogueInputs}
            sectionTitle={'Analogue Inputs'}
            fieldLabel={'Analogue Input'}
            classes={props.classes}
            probeTypes={props.probeTypes}
            changeHandler={this.handleStateObjectChange}
            state={state}
           />
        }
        {
          voltageInputs && (voltageInputs.length > 0) && <HardwareInputsSettingsSection
            inputType={'voltage'}
            inputsArray={voltageInputs}
            sectionTitle={'Voltage Inputs'}
            fieldLabel={'Voltage Input'}
            classes={props.classes}
            probeTypes={props.probeTypes}
            changeHandler={this.handleStateObjectChange}
            state={state}
           />
        }
        {
          pulseSwitchInputs && (pulseSwitchInputs.length > 0) && <HardwareInputsSettingsSection
            inputType={'pulseSwitch'}
            inputsArray={pulseSwitchInputs}
            sectionTitle={'Pulse/Switch Inputs'}
            fieldLabel={'Pulse/Switch Input'}
            classes={props.classes}
            probeTypes={props.probeTypes}
            changeHandler={this.handleStateObjectChange}
            state={state}
           />
        }
        {
          sdi12Inputs && (sdi12Inputs.length > 0) && <Sdi12InputsSettingsSection
            inputType={'sdi12'}
            inputsArray={sdi12Inputs}
            sectionTitle={'SDI-12 Inputs'}
            fieldLabel={'SDI-12 Input'}
            classes={props.classes}
            probeTypes={props.probeTypes}
            changeHandler={this.handleStateObjectChange}
            sensorEnabledButtonClickHandler={this.sdi12SensorEnabledButtonClickHandler}
            state={state}
           />
        }
        <div className={props.classes.formSectionHeading}>Graph Min &amp; Max</div>
        {state.units.map((unit,index) => {
          return <Grid container key={index} spacing={24}>
          <Grid item xs={12} sm={1} className={classes.graphSettingsUnitCell}>
              {unit.unit}
            </Grid>
            <Grid item xs={12} sm={5}>
              <FormControl fullWidth={true} className={classes.formControl}>
                <TextField
                  type="number"
                  className={props.classes.textField}
                  error={state.nameError}
                  id={`textinput-graph-min-${unit.unit_key}`}
                  name={`graphMin[${unit.unit_key}]`}
                  label={`Graph Minimum - ${unit.unit}`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state['graphMin'][`${unit.unit_key}`]}
                  onChange={this.handleKeyedInputChange('graphMin',unit.unit_key)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={5}>
              <FormControl fullWidth={true} className={classes.formControl}>
                <TextField
                  type="number"
                  className={props.classes.textField}
                  error={state.nameError}
                  id={`textinput-graph-max-${unit.unit_key}`}
                  name={`graphMax[${unit.unit_key}]`}
                  label={`Graph Maxiumum - ${unit.unit}`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state['graphMax'][`${unit.unit_key}`]}
                  onChange={this.handleKeyedInputChange('graphMax',unit.unit_key)}
                />
              </FormControl>
            </Grid>
          </Grid>
        })}
        <div className={props.classes.formSectionHeading}>Graph Refill &amp; Full Point</div>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={1} className={classes.graphSettingsUnitCell}>
            {state['graphFullRefillPoint'] && state['graphFullRefillPoint']['unit']}
          </Grid>
          <Grid item xs={12} sm={5}>
            <FormControl fullWidth={true} className={classes.formControl}>
              <TextField
                type="number"
                className={props.classes.textField}
                error={state.nameError}
                id={`textinput-graph-refill-point`}
                name={`graphRefillPoint`}
                label={`Refill Point`}
                InputLabelProps={{
                  shrink: true,
                }}
                value={state['graphFullRefillPoint']['refill_point']}
                onChange={this.handleKeyedInputChange('graphFullRefillPoint','refill_point')}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={5}>
            <FormControl fullWidth={true} className={classes.formControl}>
              <TextField
                type="number"
                className={props.classes.textField}
                error={state.nameError}
                id={`textinput-graph-full-point`}
                name={`graphFullPoint`}
                label={`Full Point`}
                InputLabelProps={{
                  shrink: true,
                }}
                value={state['graphFullRefillPoint']['full_point']}
                onChange={this.handleKeyedInputChange('graphFullRefillPoint','full_point')}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          {state.errors && state.errors && Object.keys(state.errors).map((error) => <div><FormHelperText error>{state.errors[error]}</FormHelperText></div>)}
        </Grid>
        <Grid container spacing={24} className={classes.saveButtonContainer}>
          <Button variant="contained" size="medium" color="primary" className={classes.button}>
            Save Site
          </Button>
        </Grid>
      </form>
    </Paper>
  }

  render() {
    console.log('this.state',this.state)
    return this.renderBody(this.props,this.state)
  }
}

export default withStyles(styles)(SiteConfigForm)



// WEBPACK FOOTER //
// ./src/components/forms/SiteConfigForm.js